import React from "react";
import { styled } from "@mui/system";
import { Typography } from "@mui/material";
import Avatar from "../../../shared/components/Avatar";
import VoiceCallButton from "../VoiceCallButton";

const MainContainer = styled("div")({
  width: "98%",
  marginTop: "10px",
});
const TopRow = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});
const ProfileRow = styled("div")({
  display: "flex",
  alignItems: "center",
  minWidth: 0,
});
const MessagesHeader = ({ id, name }) => {
  return (
    <MainContainer>
      <TopRow>
        <ProfileRow>
          <Avatar large username={name} />
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "white",
              marginLeft: "10px",
              marginRight: "5px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {name}
          </Typography>
        </ProfileRow>
        <VoiceCallButton receiverUserId={id} />
      </TopRow>
      <Typography
        sx={{ color: "#b9bbbe", marginLeft: "5px", marginRight: "5px" }}
      >
        Это начало вашей переписки с {name}
      </Typography>
    </MainContainer>
  );
};

export default MessagesHeader;
